export default __webpack_public_path__ + "static/media/E-WEB-Goal-08.11c4c71e.png";